export default "__VITE_ASSET__994e6c85__"